import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Gauge } from "lucide-react";

// Popup di dettaglio Compliance (5 pilastri) — identico a quello dell'agente.
// Riceve i dati già caricati da /dashboard/my-valutazione (compliance_pct + compliance_detail).
export default function ComplianceDetailDialog({ open, onOpenChange, data }) {
  const comp = data?.compliance_pct;
  const det = data?.compliance_detail;
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="agency-compliance-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><Gauge className="h-5 w-5 text-primary" /> Compliance {comp != null ? `· ${comp}%` : ""}</DialogTitle>
          <DialogDescription>Come si calcola e il calcolo effettivo del periodo.</DialogDescription>
        </DialogHeader>
        {!det ? (
          <div className="p-4 text-sm text-muted-foreground">Dettaglio non disponibile.</div>
        ) : (
          <div className="max-h-[70vh] space-y-4 overflow-y-auto pr-1" data-testid="agency-compliance-detail-body">
            <div className="rounded-lg border border-white/10 bg-white/[0.03] p-3">
              <div className="mb-1 text-[10px] font-bold uppercase tracking-wide text-primary">1 · Come si calcola</div>
              <p className="text-xs leading-relaxed text-muted-foreground">
                La Compliance è la <b className="text-foreground">media pesata</b> di 5 pilastri ({det.pilastri.map((p) => `${p.label} ${p.peso}`).join(" · ")}). Calcolo <b className="text-foreground">cumulativo</b> dal <b className="text-foreground">{det.periodo_da}</b> a oggi, contando <b className="text-foreground">solo i giorni feriali</b>{det.giorni_feriali != null ? ` (${det.giorni_feriali} finora)` : ""} — sabato, domenica e festivi esclusi. Ogni pilastro dà <b className="text-foreground">punti = score% × peso ÷ 100</b>; i pilastri senza dati vengono esclusi e i pesi rinormalizzati (voto = punti totali ÷ pesi disponibili).
              </p>
              <ul className="mt-2 space-y-1.5">
                {det.pilastri.map((p) => (
                  <li key={p.key} className="text-xs">
                    <span className="font-semibold text-foreground">{p.label} <span className="text-primary">({p.peso}%)</span></span>{" — "}
                    <span className="text-muted-foreground">{p.teoria}</span>
                  </li>
                ))}
              </ul>
            </div>
            <div className="rounded-lg border border-white/10 bg-black/20 p-3">
              <div className="mb-2 text-[10px] font-bold uppercase tracking-wide text-primary">2 · Come nasce il {det.risultato != null ? `${det.risultato}%` : "voto"} · dal {det.periodo_da} a oggi</div>
              <div className="space-y-2">
                {det.pilastri.map((p) => {
                  const na = p.score == null;
                  return (
                    <div key={p.key} className="rounded border border-white/5 bg-white/[0.02] p-2" data-testid={`agency-compliance-pillar-${p.key}`}>
                      <div className="flex items-center justify-between gap-2">
                        <span className="text-xs font-semibold text-foreground">{p.label} <span className="text-muted-foreground">· vale {p.peso}%</span></span>
                        <span className={`rounded-full px-2 py-0.5 text-[11px] font-bold ${na ? "bg-muted text-muted-foreground" : "bg-primary/15 text-primary"}`}>{na ? "Non valutata" : `${p.score}%`}</span>
                      </div>
                      <div className="mt-0.5 text-[11px] text-muted-foreground">{p.calcolo}</div>
                      {na
                        ? <div className="mt-0.5 text-[10px] text-amber-500">Non ancora valutata: non pesa sul voto</div>
                        : <div className="mt-0.5 text-[10px] text-muted-foreground">Porta <b className="text-foreground">{String(p.punti).replace(".", ",")}</b> punti su {p.peso}</div>}
                    </div>
                  );
                })}
              </div>
              <div className="mt-3 border-t border-white/10 pt-2 text-xs" data-testid="agency-compliance-formula-total">
                <div className="text-muted-foreground">Totale: <b className="text-foreground">{String(det.punti_totali).replace(".", ",")} punti</b> su {det.pesi_disponibili} disponibili = <b className="text-primary">{det.risultato != null ? `${det.risultato}%` : "—"}</b></div>
              </div>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
